var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.currentCart).length > 0)?_c('div',{staticClass:"mt-2 mb-5"},[_c('a',{staticClass:"submit-btn go-to-cart-link",attrs:{"href":"/carts"}},[_vm._v("查看購物車 & 結賬")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }